import React from "react";
import SummaryCard from "./shared/SummaryCard";
import { wholeNumberWithCommas } from "../utils/NumberFormatter";
import { ErrorOutlineOutlined } from "@material-ui/icons";
import { MappingWarningIcon } from "./shared/MappingIcons";

const EntitySummary = ({
  title,
  subtitle,
  rowCount,
  conformingPercentage,
  stats = [],
  table,
  numberColumns,
  showWarning = false,
}) => {
  return (
    <div className="entity_summary">
      <div className="entity_summary__header">
        <div className="entity_summary__header__title">
          {title}
          <div className="flex gap--4 align-items-center">
            {showWarning && <MappingWarningIcon />}
            {subtitle}{" "}
          </div>
        </div>
        <div className="entity_summary__header__numbers">
          <span className="entity_summary__title">{rowCount} rows</span>
          {conformingPercentage != null && (
            <span className="entity_summary__subtitle">{conformingPercentage}% Conforming</span>
          )}
        </div>
      </div>
      <div className="entity_summary__stats" style={{ "--column-count": numberColumns }}>
        {stats.map((s) => {
          return (
            <div key={s.title} className="flex flex-column">
              <div className="entity_summary__subtitle--upcase">{s.title}</div>
              <div className="entity_summary__stats__value">{s.count}</div>
            </div>
          );
        })}
      </div>
      <div className="entity_summary__table-container">{table}</div>
    </div>
  );
};

export default EntitySummary;
